import { useQuery } from '@tanstack/react-query';
import {
  getDistrictReadiness,
  getSchoolReadiness,
  getComplianceReport,
} from '../../services/documents.service';

export const documentKeys = {
  all: ['documents'] as const,
  districtReadiness: () =>
    [...documentKeys.all, 'districtReadiness'] as const,
  schoolReadiness: (schoolId: number) =>
    [...documentKeys.all, 'schoolReadiness', schoolId] as const,
  compliance: (eventPublicId: string) =>
    [...documentKeys.all, 'compliance', eventPublicId] as const,
};

export function useDistrictReadiness() {
  return useQuery({
    queryKey: documentKeys.districtReadiness(),
    queryFn: getDistrictReadiness,
  });
}

export function useSchoolReadiness(schoolId: number) {
  return useQuery({
    queryKey: documentKeys.schoolReadiness(schoolId),
    queryFn: () => getSchoolReadiness(schoolId),
    enabled: !!schoolId,
  });
}

export function useComplianceReport(eventPublicId: string) {
  return useQuery({
    queryKey: documentKeys.compliance(eventPublicId),
    queryFn: () => getComplianceReport(eventPublicId),
    enabled: !!eventPublicId,
  });
}
